import { render, staticRenderFns } from "./ModulesSettings.vue?vue&type=template&id=2bb14bac&"
import script from "./ModulesSettings.vue?vue&type=script&lang=js&"
export * from "./ModulesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports